<template>
  <bb-button-base
    component="button"
    type="button"
    :disabled="disabled"
    :variant="variant"
    :size="size"
    :loading="loading"
    :custom="custom"
  >
    <slot />
  </bb-button-base>
</template>

<script lang="ts" setup>
import BbButtonBase, { type BbButtonBaseProps } from './BbButtonBase.vue';

defineProps<BbButtonBaseProps>();
</script>
